import classNames from 'classnames';
import React from 'react';


import Iceberg from 'ui-lib-12traits/src/Icons/svg/common/footer-iceberg.svg?component';

import styles from './Footer.module.scss';

interface Props {
  isNoBgColor?: boolean;
  isInnerPage?: boolean;
  isFixed?: boolean;
}

function Footer({ isNoBgColor, isInnerPage, isFixed }: Props): React.ReactElement {
  return <div
    className={classNames(styles.footer, {
      [styles['footer--no-background-color']]: isNoBgColor,
      [styles['footer--inner-page']]: isInnerPage,
      [styles['footer--fixed']]: isFixed
    })}
  >
    <div className={styles['footer--sky']} />
    <div className={styles['footer--game']} />
    <div className={styles['footer--iceberg']}>
      <Iceberg />
    </div>
  </div>
}

export default Footer;
